<template>
    <div class="pull-right">
        <button @click.prevent="exportXlsx" :disabled="disabled" class="btn btn-primary">{{
                $lang('Eksport XLSX')
            }}
        </button>
        <loading-widget></loading-widget>
    </div>
</template>

<script>
import ShowNotification from "../../mixins/show-notification";
import LoadingWidget from "../loading-widget.vue";
import {EventBus} from "../../mixins/event-bus";

export default {
    components: {LoadingWidget},
    props: ['url', 'admin', 'file_prefix'],
    data() {
        return {
            disabled: false,
            columns: [
                {
                    property: 'id',
                    label: this.$lang('ID'),
                    access: true
                },
                {
                    property: 'jira_id',
                    label: this.$lang('JIRA ID'),
                    access: this.admin
                },
                {
                    property: 'subject_alternative',
                    label: this.$lang('Temat'),
                    access: this.admin
                },
                {
                    property: 'subject',
                    label: this.$lang('Temat'),
                    access: !this.admin
                },
                {
                    property: 'reported_at',
                    label: this.$lang('Data zgłoszenia'),
                    access: true
                },
                {
                    property: 'sla_deadline',
                    label: this.$lang('Termin realizacji'),
                    access: this.admin
                },
                {
                    property: 'personName',
                    label: this.$lang('Osoba zgłaszająca'),
                    access: true
                },
                {
                    property: 'consultantName',
                    label: this.$lang('Osoba odpowiedzialna'),
                    access: this.admin
                },
                {
                    property: 'moduleName',
                    label: this.$lang('Moduł'),
                    access: true
                },
                {
                    property: 'criteriaName',
                    label: this.$lang('Kryterium'),
                    access: true
                },
                {
                    property: 'statusName',
                    label: this.$lang('Status'),
                    access: true
                }
            ],
        }
    },
    mixins: [ShowNotification],
    methods: {
        exportXlsx() {
            let self = this;
            EventBus.$emit('showLoader');
            self.disabled = true;
            axios({
                method: 'post',
                url: self.url,
                responseType: 'blob',
                data: {
                    columns: self.columns.filter(x => x.access)
                }
            })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', self.file_prefix + parseInt(Date.now() / 1000) + '.xlsx');
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(function (error) {
                    self.showNotification("error", self.$lang("Wystąpił błąd podczas eksportu pliku"));
                    console.log(error);
                })
                .finally(function () {
                    EventBus.$emit('hideLoader');
                    self.disabled = false;
                });
        }
    }
}
</script>

